import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppSettingsService } from './app-settings.service';
import {
  InformationProcessingCardResponse,
  SaveInformationProcessingCardsRequest,
  SystemSettingsResponse,
  UpdateNotificationRulesPayload,
  UpdateNotificationRuleTemplatePayload,
  UpdateSystemSettingsPayload,
} from '../../shared/models/system-settings';

@Injectable({
  providedIn: 'root',
})
export class SystemSettingsService extends AppSettingsService {
  constructor(private readonly http: HttpClient) {
    super();
  }

  getSettings() {
    return this.http.get<SystemSettingsResponse>(`${this.apiUrl}/api/system-settings`);
  }

  updateSettings(payload: UpdateSystemSettingsPayload) {
    return this.http.put<void>(`${this.apiUrl}/api/system-settings`, payload);
  }

  updateNotificationRules(payload: UpdateNotificationRulesPayload) {
    return this.http.put<void>(`${this.apiUrl}/api/system-settings/notification-rules`, payload);
  }

  updateNotificationTemplate(payload: UpdateNotificationRuleTemplatePayload) {
    return this.http.put<void>(`${this.apiUrl}/api/system-settings/notification-rules/template`, payload);
  }

  getInformationProcessingCards() {
    return this.http.get<InformationProcessingCardResponse[]>(`${this.apiUrl}/api/system-settings/information-processing`);
  }

  saveInformationProcessingCards(payload: SaveInformationProcessingCardsRequest) {
    return this.http.put<void>(`${this.apiUrl}/api/system-settings/information-processing`, payload);
  }

  deleteInformationProcessingCard(id: number) {
    return this.http.delete<void>(`${this.apiUrl}/api/system-settings/information-processing/${id}`);
  }
}
